import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface BreadcrumbItem {
  title: string;
  to?: string;
  disabled?: boolean;
}

export interface BreadcrumbAction {
  title: string;
  icon: string;
  handler: () => void;
}

/**
 * Holds dynamic breadcrumb segments (e.g. a robot serial number or a project
 * name) that are appended after the static segments defined in the route meta,
 * plus optional actions rendered as a "..." menu next to the breadcrumb (e.g.
 * archiving the current project). Views set them once their data is loaded;
 * they are cleared automatically on every route change.
 */
const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const dynamicItems = ref<BreadcrumbItem[]>([]);
  const actions = ref<BreadcrumbAction[]>([]);

  const setDynamicItems = (items: BreadcrumbItem[]) => {
    dynamicItems.value = items;
  };

  const setActions = (newActions: BreadcrumbAction[]) => {
    actions.value = newActions;
  };

  const clearDynamicState = () => {
    dynamicItems.value = [];
    actions.value = [];
  };

  return {
    dynamicItems,
    actions,
    setDynamicItems,
    setActions,
    clearDynamicState,
  };
});

export default useBreadcrumbStore;
